// extracted by mini-css-extract-plugin
module.exports = {"DescriptionWrapper":"Description_DescriptionWrapper__3caL_"};